export const faq = {
    title: 'よくある質問',
    titleStaking: ' INOを購入する条件は何ですか?',
    subTitleStaking:
        'INO ラウンドで NFT を購入するには、以下の手順を実行する必要があります：<br> <br>' +
        '<b>ステップ1</b>: AIS アプリを以下からダウンロードします：<br>' +
        "- Android: <a href=' https://ste.sbgroup.finance/apk/ste-app-release-v2.apk'> https://ste.sbgroup.finance/apk/ste-app-release-v2.apk</a><br>" +
        "- iOS: <a href='https://testflight.apple.com/join/xaFDhi6Y'>https://testflight.apple.com/join/xaFDhi6Y</a><br><br>" +
        '<b>ステップ2</b>: ユーザーは指示に従ってKYCを実行し、確認を受け取ります<br>' +
        'KYC 認証済みアカウントのみが INO ラウンドに参加する資格があります。',
    titleStakingHold: '<b>2. NFTを購入するメリットは何ですか？</b>',
    subTitleStakingHold:
        'この INO でオリジナルの NFT を $250/NFT で購入すると、プレーヤーは1日あたりわずか3分の運動で$15を獲得できます。 ' +
        'わずか20日で資本回収期間が完了し、30日で最大$450を獲得できます。<br><br>' +
        'さらに、非常に魅力的なNFTミントメカニズムにより、1ペアのNFT（男性 + 女性）からNFTの7つ子を作成できます。' +
        'プレーヤーは、少なくとも $2700/30 日をすぐに簡単に稼ぐことができ、毎日 5 分間の定期的な練習でそれ以上を簡単に稼ぐことができます。<br>' +
        '得られる利益は、投資した初期資金の何倍にもなります。<br><br>',
    titleStakingInformation: '<b>3. STNトークンとは何ですか？</b>',
    subTitleStakingInformation:
        'AIS は、Stretch-to-Earn（ストレッチして稼ぐ）の代表的なトークンであり、SB とリンクされて、このアプリを中心としたユーティリティを作成します。<br>' +
        'AIS トークンに関する基本情報をご覧ください：<br>' +
        '- 記号： AIS<br>' +
        '- 総供給量： 10.000.000',
    titleInterestAfter: '<b>4. 質問が必要なときには、誰に連絡すればよいですか？</b>',
    subTitleInterestAfter: 'ご質問がございましたら、以下までお問い合わせください：<a>info@dragonsb.finance</a>',
    titleNotReceivingInterest: '<b>5. AIS について詳しくはどこで確認できますか？</b>',
    subTitleNotReceivingInterest:
        'AIS について詳しくは、ブログをご覧ください。<br>' +
        '- $AIS について： <a href="https://blog.dragonsb.finance/ste-the-heart-of-stretch-to-earn/">https://blog.dragonsb.finance/ste-the-heart-of-stretch-to-earn/</a><br>' +
        '- AISの仕組みと経済性について： <a href="https://blog.dragonsb.finance/a-super-rare-chance-to-hunt-nft-from-hot-trend-stretch-to-earn/"> https://blog.dragonsb.finance/a-super-rare-chance-to-hunt-nft-from-hot-trend-stretch-to-earn/</a><br>',
};
